<template>
  <v-dialog
    v-model="visible"
    max-width="400"
    persistent
  >
    <v-form ref="form" @submit.prevent="submit">
      <v-card>
        <v-card-title class="primary white--text">
          Kreiranje domene
        </v-card-title>

        <v-card-text class="pt-4">
          <p class="mb-4">
            Firma nema domenu. Domena je potrebna za kreiranje korisnika sa email adresom u formatu "username@domena.aikasa".
          </p>

          <v-text-field
            v-model="domain"
            label="Domena"
            outlined
            dense
            @keypress="checkInput($event)"
            :rules="[rules.req(), rules.reserved]"
            hint="Samo slova i brojevi (bez razmaka i specijalnih znakova)"
            persistent-hint
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="close" :disabled="submitting">
            Odustani
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="submitting"
          >
            Spremi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import rules from '@/plugins/rules'
import { auth, df, firebase } from '@/plugins/firebase'

export default {
  name: 'AddDomainDialog',
  inject: ['showMsgBox'],
  data () {
    return {
      visible: false,
      company: null,
      domain: '',
      submitting: false,
      reservedDomains: [],
      rules: {
        req: rules.req,
        reserved: () => true // Će biti postavljen u open()
      }
    }
  },
  methods: {
    async open (company) {
      this.company = company
      this.visible = true

      // Učitaj rezervisane domene
      try {
        const doc = await df.doc('companies_domain/data').get()
        this.reservedDomains = doc?.data()?.domains || []
      } catch (error) {
        console.error('Error loading reserved domains:', error)
        this.reservedDomains = []
      }

      // Postavi validation rule za rezervisane domene
      this.rules.reserved = (val) => !this.reservedDomains.includes(val) || `Domena ${val} je već zauzeta.`

      // Generiraj defaultnu domenu
      this.setDefaultDomain()
    },
    close () {
      this.visible = false
      this.resetDefaults()
    },
    setDefaultDomain () {
      // Konvertuj ime firme u domenu
      let domainName = this.company.name

      // Problem sa Đ https://stackoverflow.com/questions/2362810/why-doesnt-%C4%90-get-flattened-to-d-when-removing-accents-diacritics
      const map = {
        d: 'đ',
        D: 'Đ'
      }
      for (const pattern in map) {
        domainName = domainName.replace(new RegExp(map[pattern], 'g'), pattern)
      }

      // Ukloni dijakritičke znakove i specijalne znakove
      this.domain = domainName
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .replace(/[^0-9a-zA-Z]+/g, '')
        .substring(0, 20)
        .toLowerCase()
    },
    checkInput (ev) {
      // Dozvoli samo slova i brojeve
      const maskRe = /[A-Za-z0-9]/
      if (!maskRe.test(ev.key)) {
        ev.preventDefault()
        return false
      }
    },
    resetDefaults () {
      this.company = null
      this.domain = ''
      this.submitting = false
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    async submit () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.submitting = true

      try {
        // Ažuriraj domenu u companies kolekciji
        await df.doc(`companies/${this.company.id}`).update({
          domain: this.domain
        })

        // Ažuriraj domenu u user_companies kolekciji
        await df.doc(`user_companies/${auth.currentUser.uid}`).update({
          [`companies.${this.company.id}.domain`]: this.domain
        })

        // Dodaj domenu u rezervisane domene
        await df.doc('companies_domain/data').update({
          domains: firebase.firestore.FieldValue.arrayUnion(this.domain)
        })

        this.showMsgBox({
          text: `Domena "${this.domain}" je uspješno kreirana`,
          color: 'success'
        })

        // Emituj event sa domenom
        this.$emit('domainCreated', this.domain)

        this.close()
      } catch (error) {
        console.error('Error creating domain:', error)
        this.showMsgBox({
          text: 'Greška pri kreiranju domene',
          color: 'error'
        })
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
